import Vue from 'vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

Vue.component('promo-bar', {
  name: 'promoBar',
  data () {
    return {
      activeIndex: 0,
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        keyboard: true,
        mousewheel: true
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    resizeHandler (event) {
      this.$refs.swiperRefDesktop.swiper.slideTo(this.activeIndex)
    }
  },
  created () {
    this.innerWidth = window.innerWidth
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.resizeHandler)
  }
})
